<template>
  <div>
    <div class="pageMain" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''">
      <div class="banner perBan">
        <img :src="banners.image" alt="">
        <div class="w1440">
          <div class="txt">
            <p class="fnt_52">
              {{ globalDataArray.siteTemplateLanguage.banner_welcome }}

              <template v-if="saitiAccessInfo.nickname!='' && saitiAccessInfo.nickname!=null && saitiAccessInfo.nickname!=undefined">
                {{ saitiAccessInfo.nickname }}
              </template>

              <template v-else-if="saitiAccessInfo.username!='' && saitiAccessInfo.username!=null && saitiAccessInfo.username!=undefined">
                {{ saitiAccessInfo.username }}
              </template>
            </p>
            <span class="fnt_18 mail" v-if="saitiAccessInfo.email!='' && saitiAccessInfo.email!=null && saitiAccessInfo.email!=undefined">
              {{ saitiAccessInfo.email }}
            </span>
            <span class="fnt_18" v-else-if="saitiAccessInfo.phone!='' && saitiAccessInfo.phone!=null && saitiAccessInfo.phone!=undefined">
              {{ saitiAccessInfo.phone }}
            </span>
          </div>
        </div>
      </div>

      <div class="personPage">
        <div class="cf w1440">
          <div class="personLeft">
            <personmenu />
          </div>

          <div class="personRight">
            <div class="tit fnt_32">{{ globalDataArray.siteTemplateLanguage.person_signup_record }}</div>

            <div class="antDesignTable">
              <a-table
                row-key="id"
                :scroll="{x:true}"
                :columns="columns"
                :data-source="list"
                :pagination="paginationOpt"
                class="j-table-force-nowrap"
              >
                <template slot="tit" slot-scope="text, record">
                  <router-link
                    target="_blank"
                    v-if="record.competitionDelflag=='0' && record.competitionStatus=='1'"
                    :to="{
                      path: '/competitionInfo',
                      query: {
                        id: record.competitionParentId,
                        checkStatus: record.checkStatus
                      }
                    }"
                    class="compNameBtn title_first"
                    :title="text"
                  >
                    {{ text }}
                  </router-link>
                  <span :title="text" v-else class="compNameBtn title_first" @click="delCancel(record)">{{ text }}</span>
                </template>

                <template slot="curstatus" slot-scope="text, record">
                  <template v-if="record.competitionDelflag=='1'">
                    {{ globalDataArray.siteTemplateLanguage.has_delete }}
                  </template>

                  <template v-else-if="record.competitionStatus=='0'">
                    {{ globalDataArray.siteTemplateLanguage.has_cancel }}
                  </template>

                  <template v-else>
                    <template v-if="record.competitionSignup=='03'">
                      <template v-if="currentTime < record.localEndtimeStr">
                        {{ record.competitionSignup_dictText }}
                      </template>

                      <!-- 截止报名 -->
                      <template v-if="currentTime >= record.localEndtimeStr">
                        {{ globalDataArray.siteTemplateLanguage.competition_signup_end }}
                      </template>
                    </template>

                    <template v-else>
                      {{ record.competitionSignup_dictText }}
                    </template>
                  </template>
                </template>

                <span slot="checkStatus" slot-scope="text, record">
                  <!-- <a-tooltip placement="topRight">
                    <template slot="title" v-if="record.checkStatus!='03' && record.checkRemark!=null && record.checkRemark!==''">
                      <span v-html="record.checkRemark.replaceAll('\n','<br />')"></span>
                    </template>
                    <span v-html="text" class="mr6"></span><a-icon type="info-circle" style="color: rgba(0,0,0,.45)" v-if="record.checkStatus!='03' && record.checkRemark!=null && record.checkRemark!==''" />
                  </a-tooltip> -->
                  <a-tooltip placement="topRight">
                    <!-- 如果是 '03'，显示"报名成功" -->
                    <span v-if="record.checkStatus === '03'">
                      {{ globalDataArray.siteTemplateLanguage.registrantion_successful }}
                    </span>

                    <!-- 否则正常显示 text，并带 tooltip 提示 checkRemark -->
                    <template v-else>
                      <template slot="title" v-if="record.checkStatus != '03' && record.checkRemark != null && record.checkRemark !== ''">
                        <span v-html="record.checkRemark.replaceAll('\n','<br />')"></span>
                      </template>
                      <span v-html="text" class="mr6"></span>
                      <a-icon
                        type="info-circle"
                        style="color: rgba(0,0,0,.45)"
                        v-if="record.checkStatus != '03' && record.checkRemark != null && record.checkRemark !== ''"
                      />
                    </template>
                  </a-tooltip>
                </span>
                <span slot="awardNames" slot-scope="text, record" @click="queryCertificatesList(record.id)" class="compEditBtn mr8" v-if="Number(record.awardRecord) === 1">
                  {{ globalDataArray.siteTemplateLanguage.select || '查看' }}
                </span>

                <template slot="action" slot-scope="text, record">
                  <div class="antTableAction">
                    <div v-if="record.checkStatus === '3'">
                      <span @click="clickInfo(record, 'see')" class="compEditBtn mr8">{{ globalDataArray.siteTemplateLanguage.select || '查看' }}</span>
                    </div>
                    <div v-else>
                      <a-dropdown>
                        <a class="ant-dropdown-link" @click.prevent>
                          {{ globalDataArray.siteTemplateLanguage.more || '更多' }}
                          <a-icon type="down" />
                        </a>
                        <template #overlay>
                          <a-menu>
                            <template>
                              <a-menu-item @click="clickInfo(record, 'edit')" v-if="(record.isCaptain === 1
                                || (record.isCaptain === 0 && record.checkStatus !== '09' && record.checkStatus !== '08'))
                                && currentTime <= record.localEndtimeStr">
                                <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.team_information || '团队信息' }}</a>
                              </a-menu-item>
                              <a-menu-item @click="clickInfo(record, 'see')" v-if="currentTime >= record.localEndtimeStr">
                                <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.team_information || '团队信息' }}</a>
                              </a-menu-item>
                              <a-menu-item v-if="currentTime <= record.localEndtimeStr" @click="editPerson(record)" v-show="getMemberIstegg(record)">
                                <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.edit || '编辑' }}</a>
                              </a-menu-item>
                              <a-menu-item @click="improveInfo(record)" v-if="record.certificatesContext">
                                <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.improve_information || '完善认证信息' }}</a>
                              </a-menu-item>
                              <a-menu-item @click="multiLanguageInfo(record)" v-if="record.certificatesContext">
                                <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.improve_information2 || '完善证书信息' }}</a>
                              </a-menu-item>
                              <a-menu-item @click="unSubmit(record)" v-if="currentTime <= record.localEndtimeStr">
                                <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.unregister || '取消报名' }}</a>
                              </a-menu-item>
                              <!-- <a-menu-item @click="seeInfo(record)">
                                <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.person_team_member }}</a>
                              </a-menu-item> -->
                              <a-menu-item @click="submitWork(record)" v-if="record.competitionAtomgitOrgInfo && record.checkStatus === '03'">
                                <a href="javascript:;">{{ globalDataArray.siteTemplateLanguage.upload_work || '提交作品' }}</a>
                              </a-menu-item>
                            </template>
                          </a-menu>
                        </template>
                      </a-dropdown>
                    </div>
                  </div>
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <personedit :personedit.sync="personedit" :curid.sync="curid" @SignupRecordList="SignupRecordList" />
    <!--    修改报名信息弹框-->
    <!--    <formsign :formsign.sync="formsign" :cur-info-array.sync="curInfoArray" :person-list="personList" @itemclick="formsignFun"/>-->
    <formsign-new :formsign.sync="formsign" :cur-info-array.sync="curInfoArray" :person-list="personList" @itemclick="formsignFun" :title-name="globalDataArray.siteTemplateLanguage.team_information" :sub-button="globalDataArray.siteTemplateLanguage.submit" :read-only="personReadly" @SignupRecordList="SignupRecordList" />

    <improve-info ref="improveInfo" :info-pop.sync="infoPop" :info-data="personInfo" />
    <multi-language-info :visible.sync="multiLanguageVisible" :record-data="multiLanguageRecord" />
    <formmsg-edit-new :formsign.sync="formmsg" :cur-info-array.sync="personEditInfo" :team-array="personEditInfo" :person-list="personEdit" :sub-button="globalDataArray.siteTemplateLanguage.submit" :title-name="globalDataArray.siteTemplateLanguage.modify_personaal" @SignupRecordList="SignupRecordList" />
    <PersonCheck :infoPop.sync="personPop" :check-list="checkList" :person="person" @init="init" />
    <privacy-statement :privacy-statement.sync="privacyStatement" :cur-info-array.sync="privacyStatementRecord" @itemclick="privacyStatementFun" />
  </div>
</template>

<script>
import { stringToDateTime } from '@/utils/util'
import {
  cancelRecord,
  createAtomGitRepo,
  selectOneTeamRecord,
  SignupRecordList,
  teamRecord,
  getUserInfoBySignupId,
  getMemberBySourceId,
  cancelLog
} from '@/api/person/person'
import { message } from 'ant-design-vue'
import Cookies from 'js-cookie'
import { getAdList, getCertificates } from '@/api/api'
import Formsign from '@/components/global/formsign/index.vue'
import ImproveInfo from '@/views/person/component/ImproveInfo.vue'
import MultiLanguageInfo from '@/views/person/component/MultiLanguageInfo.vue'
import FormsignNew from '@/components/global/formsign/FormsignNew.vue'
import dayjs from 'dayjs'
import FormmsgEditNew from '@/components/global/formmsg/FormmsgNew.vue'
import PersonCheck from '@/views/person/component/PersonCheck.vue'
import PrivacyStatement from '@/components/global/privacyStatement/index.vue'

export default {
  name: 'Myrecord',
  components: { FormmsgEditNew, FormsignNew, ImproveInfo, MultiLanguageInfo, Formsign, PersonCheck, PrivacyStatement },
  data() {
    return {
      title: this.globalDataArray.siteInfo.title,
      description: this.globalDataArray.siteInfo.description,
      keywords: this.globalDataArray.siteInfo.keywords,
      saitiAccessInfo: '',
      paginationOpt: {
        current: 1,
        total: 0,
        defaultCurrent: 1,
        defaultPageSize: 10,
        pageSize: 10,
        hideOnSinglePage: true,
        onChange: (current, size) => {
          this.defaultPageSize = size
          this.paginationOpt.current = current
          this.SignupRecordList()
        },
        // onChange:在分页数量和当前页发生变化时触发
        onShowSizeChange: (current, pageSize) => {
          this.paginationOpt.pageSize = pageSize
        }
      },
      currentTime: new Date().getTime(), // 当前地区时区时间时间戳
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (text, record, index) => {
            return ((this.paginationOpt.current - 1) * this.paginationOpt.pageSize + index + 1)
          }
        },
        {
          title: '赛事名称',
          align: 'center',
          width: 180,
          dataIndex: 'competitionTitle',
          scopedSlots: { customRender: 'tit' },
          ellipsis: true,
          sorter: (a, b) => a.competitionTitle.length - b.competitionTitle.length
        },
        {
          title: '获奖信息',
          align: 'center',
          dataIndex: 'awardNames',
          scopedSlots: { customRender: 'awardNames' },
          sorter: (a, b) => a.awardNames.length - b.awardNames.length
        },
        {
          title: '审核状态',
          align: 'center',
          dataIndex: 'checkStatus_dictText',
          scopedSlots: { customRender: 'checkStatus' },
          sorter: (a, b) => a.checkStatus_dictText.length - b.checkStatus_dictText.length
        },
        {
          title: '比赛状态',
          align: 'center',
          dataIndex: 'competitionSignup_dictText',
          scopedSlots: { customRender: 'curstatus' },
          sorter: (a, b) => a.competitionSignup_dictText.length - b.competitionSignup_dictText.length
        },
        /*        {
          title: '赛道名称',
          width: 140,
          align: 'center',
          dataIndex: 'categoryTitle',
          sorter: (a, b) => a.categoryTitle.length - b.categoryTitle.length
        },*/
        {
          title: '报名截止时间',
          align: 'center',
          dataIndex: 'competitionEndTime',
          sorter: (a, b) => dayjs(a.competitionEndTime, 'DD-MM-YYYY HH:mm:ss').unix() - dayjs(b.competitionEndTime, 'DD-MM-YYYY HH:mm:ss').unix()
        },
        {
          title: '报名时间',
          width: 170,
          align: 'left',
          dataIndex: 'createTime',
          sorter: (a, b) => dayjs(a.createTime, 'DD-MM-YYYY HH:mm:ss').unix() - dayjs(b.createTime, 'DD-MM-YYYY HH:mm:ss').unix()
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      checkList: [],
      list: [],

      personedit: false,
      curid: {},
      banners: {},
      formsign: false, // 修改弹窗
      curInfoArray: {},
      personList: {
        temp: []
      },
      infoPop: false,
      formmsg: false, // 信息弹窗
      personEditInfo: {},
      personEdit: {}, // 编辑弹窗
      personReadly: false,
      personInfo: {},
      multiLanguageVisible: false, // 多语言信息弹窗
      multiLanguageRecord: {}, // 多语言信息记录
      personPop: false,
      person: {},
      privacyStatement: false, // 隐私声明确认弹窗
      privacyStatementRecord: {} // 隐私声明记录
    }
  },
  watch: {
    personPop(val) {
      if (!val) {
        this.checkList = []
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      console.log('init')
      this.getAdList()
      this.tableHeader()
      this.SignupRecordList()
      if (Cookies.get('saiti_access_info') != '' && Cookies.get('saiti_access_info') != undefined && Cookies.get('saiti_access_info') != null) {
        this.saitiAccessInfo = JSON.parse(Cookies.get('saiti_access_info'))
      }
      // this.seeInfo();
    },
    tableHeader() {
      const that = this
      that.columns[0].title = that.globalDataArray.siteTemplateLanguage.person_table_number
      that.columns[1].title = that.globalDataArray.siteTemplateLanguage.person_table_competition_title
      // that.columns[2].title = that.globalDataArray.siteTemplateLanguage.competition_bonus
      // that.columns[4].title = that.globalDataArray.siteTemplateLanguage.person_table_competition_category
      that.columns[5].title = that.globalDataArray.siteTemplateLanguage.person_table_signup_endtime
      that.columns[4].title = that.globalDataArray.siteTemplateLanguage.person_table_status
      that.columns[6].title = that.globalDataArray.siteTemplateLanguage.person_table_signup_create_time
      that.columns[3].title = that.globalDataArray.siteTemplateLanguage.person_table_signup_check_status
      that.columns[2].title = that.globalDataArray.siteTemplateLanguage.award_information
      that.columns[7].title = that.globalDataArray.siteTemplateLanguage.person_table_controls
      // console.log(this.columns,'columns')
    },
    SignupRecordList() {
      const that = this
      const param = 'page=' + that.paginationOpt.current + '&pageSize=' + that.paginationOpt.defaultPageSize
      SignupRecordList(param).then(res => {
        if (res.success) {
          that.list = res.result.records
          that.paginationOpt.total = res.result.total

          that.list.forEach((item, index) => {
            const endUtcTime = item.endUtcTime
            const localEndtimeStr = new Date(endUtcTime).getTime()
            item['localEndtimeStr'] = localEndtimeStr
          })
        }
      })
    },
    getAdList() {
      const that = this
      const adParam = 'alias=person_banner'
      getAdList(adParam).then(res => {
        if (res.success) {
          that.banners = res.result[0]
        }
      })
    },
    async queryCertificatesList(id) {
      this.personPop = true
      try {
        const res = await getCertificates(id)
        if (res.success) {
          this.checkList = res.result.records || []
        } else {
          this.checkList = []
          this.$message.error(res.message || '获取失败')
        }
      } catch (error) {
        this.$message.error('请求异常')
      } finally {
        this.loading = false
      }
    },
    seeInfo(record) {
      // console.log(id)
      const that = this
      that.personedit = true
      that.curid = record
    },
    // 编辑
    async editPerson(record) {
      // this.personEditInfo = record
      this.personEditInfo = JSON.parse(record.sigupJson)
      this.personEditInfo.competitionId = record.competitionParentId
      console.log(this.personEditInfo, 'editPerson')
      const params = 'id=' + record.id
      const res = await selectOneTeamRecord(params)
      if (res.success) {
        const jsonTeam = JSON.parse(res.result.sigup_json)
        jsonTeam.id = res.result.id
        jsonTeam.countryCode = { key: jsonTeam.countryCode, label: jsonTeam.countryName }
        jsonTeam.cityCode = { key: jsonTeam.cityCode, label: jsonTeam.cityName }
        this.personEditInfo.parentId = res.result.parent_id
        this.personEdit = jsonTeam
        this.formmsg = true
        console.log(res.result, 'editPerson')
      }
    },

    getMemberIstegg(record) {
      const json = JSON.parse(record.sigupJson)
      if (json.userNameNew) {
        return false
      } else {
        return true
      }
    },

    delCancel(record) {
      const that = this
      if (record.competitionDelflag == '1') {
        // 已删除
        message.error(that.globalDataArray.siteTemplateLanguage.has_delete)
      } else if (record.competitionStatus == '0') {
        // 已下架
        message.error(that.globalDataArray.siteTemplateLanguage.has_cancel)
      }
    },

    // 取消报名
    unSubmit(record) {
      this.$confirm({
        title: `${this.globalDataArray.siteTemplateLanguage.delete_record}`,
        content: `${this.globalDataArray.siteTemplateLanguage.with_caution}`,
        okText: `${this.globalDataArray.siteTemplateLanguage.verify}`,
        okType: 'danger',
        cancelText: `${this.globalDataArray.siteTemplateLanguage.cancel}`,
        onOk: async () => {
          const param = 'id=' + record.id + '&isCaptain=' + record.isCaptain + '&teamNo=' + record.teamNo
          const res = await cancelRecord(param)
          if (res.success) {
            this.$message.success(this.globalDataArray.siteTemplateLanguage.success_withdrawn)
            this.SignupRecordList()
          }
        },
        onCancel: () => { // 使用箭头函数
          console.log('Cancel')
        }
      })
    },

    // 详情
    async clickInfo(record, type) {
      if (record.isCaptain === 0) {
        type = 'see'
      }
      if (type === 'see') {
        this.personReadly = true
      } else {
        this.personReadly = false
      }
      const jsonData = JSON.parse(record.sigupJson)
      record.teamsUsers = jsonData.teamsUsers
      record.competitionId = record.competitionParentId
      record.currentLanguge = jsonData.currentLanguge
      this.curInfoArray = record
      console.log(record, 'record')
      this.personList = {
        temp: []
      }
      if (record.checkStatus === '3') {
        const res = await cancelLog('signupId=' + record.id)
        if (res.success) {
          const teamList = res.result.records
          teamList.forEach(item => {
            const jsonTeam = JSON.parse(item.sigupJson)
            jsonTeam.id = item.id
            jsonTeam.countryCode = { key: jsonTeam.countryCode, label: jsonTeam.countryName }
            jsonTeam.cityCode = { key: jsonTeam.cityCode, label: jsonTeam.cityName }
            if (item.isCaptain === 1) {
              this.personList = jsonTeam
              jsonTeam.temp = []
            } else {
              this.personList.temp.push(jsonTeam)
            }
          })
          this.formsign = true
        }
        return
      }
      const params = 'competitionId=' + record.competitionId + '&parentId=' + record.parentId
      const resNew = await teamRecord(params)
      if (resNew.success) {
        const teamList = resNew.result.records
        teamList.forEach(item => {
          const jsonTeam = JSON.parse(item.sigupJson)
          jsonTeam.id = item.id
          jsonTeam.countryCode = { key: jsonTeam.countryCode, label: jsonTeam.countryName }
          jsonTeam.cityCode = { key: jsonTeam.cityCode, label: jsonTeam.cityName }
          if (item.isCaptain === 1) {
            this.personList = jsonTeam
            jsonTeam.temp = []
          } else {
            this.personList.temp.push(jsonTeam)
          }
        })
        this.formsign = true
      }
    },

    // 完善信息
    async improveInfo(record) {
      console.log(record)
      // 先显示隐私声明确认窗口
      this.privacyStatementRecord = record
      this.privacyStatement = true
    },

    // 隐私声明确认回调
    privacyStatementFun(res) {
      if (res === '1') {
        // 用户同意隐私声明，继续显示完善信息
        this.showImproveInfo()
      }
    },

    // 显示完善信息
    async showImproveInfo() {
      const record = this.privacyStatementRecord
      const params = 'id=' + record.id
      const res = await selectOneTeamRecord(params)
      const member = await getMemberBySourceId()
      const userParams = 'signupId=' + record.id
      const userInfo = await getUserInfoBySignupId(userParams)
      console.log(userInfo, 'userInfo')
      if (res.success) {
        const jsonTeam = JSON.parse(res.result.sigup_json)
        if (member && member.result && member.result.deliveryAddress) {
          jsonTeam.deliveryAddress = member.result.deliveryAddress
        }
        if (userInfo && userInfo.result) {
          jsonTeam.idCard = userInfo.result.idCard
          jsonTeam.bankCardNumber = userInfo.result.bankCardNumber
          jsonTeam.personNumber = userInfo.result.personNumber
          jsonTeam.personName = userInfo.result.personName
          jsonTeam.bankName = userInfo.result.bankName
          jsonTeam.accountName = userInfo.result.accountName
          jsonTeam.receiverPhone = userInfo.result.receiverPhone
          jsonTeam.receiverIdCard = userInfo.result.receiverIdCard
          jsonTeam.attachment = userInfo.result.attachment
          jsonTeam.id = userInfo.result.id
          if (typeof userInfo.result.deliveryAddress === 'string' &&
              userInfo.result.deliveryAddress.trim() !== '') {
            jsonTeam.deliveryAddress = userInfo.result.deliveryAddress
          }
        }
        jsonTeam.signupId = record.id
        // 添加sysOrgcode字段
        jsonTeam.sysOrgCode = record.sysOrgCode || res.result.sysOrgCode
        this.personInfo = jsonTeam
        this.infoPop = true
        this.$refs.improveInfo.init(jsonTeam)
      }
    },

    // 提交作品
    async submitWork(record) {
      console.log(record)
      if (record.gitUrl) {
        window.open(record.gitUrl, '_blank')
      }
      if (record.competitionAtomgitOrgInfo) {
        const atomgitOrgInfo = JSON.parse(record.competitionAtomgitOrgInfo)
        const param = {
          targetOrgId: atomgitOrgInfo.orgId,
          description: record.teamName,
          name: record.teamName,
          path: record.id,
          id: record.id
        }
        const res = await createAtomGitRepo(param)
        if (res.success) {
          window.open(res.result, '_blank')
        } else {
          this.$message.error(this.globalDataArray.siteTemplateLanguage.create_repository_failed || '创建仓库失败，请联系承办方')
        }
      }
    },

    // 多语言信息
    async multiLanguageInfo(record) {
      console.log(record)
      const params = 'id=' + record.id
      const res = await selectOneTeamRecord(params)
      if (res.success) {
        // 使用后端返回的数据结构
        this.multiLanguageRecord = res.result
        this.multiLanguageVisible = true
        console.log('多语言信息数据:', this.multiLanguageRecord)
      } else {
        this.$message.error('获取记录信息失败')
      }
    },

    formsignFun(res) {
      console.log(res)
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords }
      ]
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/css/person.css';
::v-deep .ant-spin-container .ant-table-scroll .ant-table-body .ant-table-fixed .ant-table-tbody > tr > td {
  padding: 16px 6px ;
}
::v-deep .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters:hover {
  background-color: #1281ff;
}
::v-deep .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-up.on, .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down.on {
  color: #d7dee7;
}
::v-deep .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner .ant-table-column-sorter-down.on {
  color: #d7dee7;
}

.title_first {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

</style>
